// extracted by mini-css-extract-plugin
export var closeButton = "ImageModal-module--closeButton--418bb";
export var content = "ImageModal-module--content--2b57e";
export var fadeInAnimation = "ImageModal-module--fadeInAnimation--5c7a2";
export var image = "ImageModal-module--image--b4af3";
export var picture = "ImageModal-module--picture--1ae2a";
export var pictureWrapper = "ImageModal-module--pictureWrapper--eb83a";